// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__bSjm2","location":"Header_location__1l2J2"};